module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"ui":{"components":{"users":{"profile":{"resume":{"action":"Add professional experience","empty_state":"Add your professional experience to demonstrate your financial expertise to visitors to your profile.","title":"Professional Experience"}}}}}}}')
  delete Component.options._Ctor
}
